import { Component, EventEmitter, Input, OnChanges,  Output, SimpleChanges } from '@angular/core';
import {  HttpClientModule } from '@angular/common/http';
import { CommonModule, NgClass } from '@angular/common';
import { RouterModule } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';
import { IconService } from './icon.service';

@Component({
  selector: 'NiFormIcon',
  standalone: true,
  styles: [
    `
:host {
  display: flex;
  justify-content: center;
  align-items: center;
}
.icon {
  display: flex;
  align-items: center;
  justify-content: center;
}
:host ::ng-deep mat-icon {
  font-size: 1.25rem;
  width: 100%;
  height: 100%;
  line-height: 1;
  display: flex;
  align-items: center;
  justify-content: center;
}
    `
  ],
  imports: [CommonModule, HttpClientModule, RouterModule, MatIconModule, NgClass],
  template: '<mat-icon *ngIf="icon" [svgIcon]="icon" class="icon" [ngClass]="iconClass"></mat-icon>'
})
export class NiIconComponent implements OnChanges {
  @Input() icon: string = '';
  @Input() iconClass: string = '';
  @Output() onClick: EventEmitter<MouseEvent> = new EventEmitter<MouseEvent>();
  private previousIcon: string = '';

  constructor(private readonly iconService: IconService) {}

  ngOnChanges(changes: SimpleChanges) {
    // Only register icon if it actually changed or is initial value
    const iconChanged = this.icon && changes['icon'] && changes['icon'].currentValue !== this.previousIcon;
    const isInitialValue = this.icon && !this.previousIcon;
    
    if (iconChanged || isInitialValue) {
      this.previousIcon = this.icon;
      this.iconService.registerIcon(this.icon);
    }
  }
}